import { z } from "zod";

/**
 * Where an API project's tests run — the environment picked in the run dialog and sent as
 * `environment_id` on `POST /schedules/`.
 *
 * Hand-written against `EnvironmentOut` in the contract (2026-09-28). The `.default()`s are
 * the contract's own declared defaults, not ours.
 */
export const Environment = z.object({
  id: z.number(),
  project_id: z.number(),
  /** Unique within the project. */
  name: z.string(),
  /** The address the tests run against; the backend allows it to be empty. */
  url: z.string().default(""),
  /** Only active environments are offered for new runs. */
  active: z.boolean().default(true),
  comment: z.string().default(""),
});
export type EnvironmentValue = z.infer<typeof Environment>;
